<template>
	<div class="forgot-password-container">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>

		<!-- Header with Mycareer title -->
		<div class="forgot-header">
			<img
            	src="https://cvstaticfiles.s3.ap-south-1.amazonaws.com/Hire3xAssests/Logo/SVG/Hire3xwhitebeta.svg"
            	alt=""
          	/>
		</div>

		<!-- Main Forgot Password Card -->
		<div class="forgot-card">
			<!-- Title Section -->
			<div class="title-section">
				<h2 class="forgot-title">Forgot Password ?</h2>
				<p class="forgot-subtitle">
					Enter the email address associated with this account.
				</p>
			</div>

			<!-- Error Message -->
			<div id="message" class="error-message"></div>

			<!-- Email Input -->
			<div class="input-group">
				<div class="input-wrapper">
					<label
						class="input-label"
						for="input-email"
						:class="{ active: email || isEmailFocused }"
						>Email</label
					>
					<b-form-input
						class="form-input"
						id="input-email"
						autofocus
						type="text"
						ref="candmail"
						v-model.trim="$v.email.$model"
						@keydown.space.prevent
						@keypress.enter="sendOTP"
						:class="{ error: $v.email.$error || invalidCredential }"
						@focus="isEmailFocused = true"
						@blur="isEmailFocused = false"
					></b-form-input>
				</div>
				<div
					class="validation-message"
					v-if="$v.email.$dirty && !$v.email.required"
				>
					Required
				</div>
				<div
					class="validation-message"
					v-else-if="
						$v.email.required && (!$v.email.email || !$v.email.alphaEmail)
					"
				>
					Invalid Email
				</div>
				<div class="validation-message" v-else-if="!$v.email.maxLength">
					Should not exceed 64 characters
				</div>
				<div class="validation-message" v-else-if="invalidCredential">
					{{ invalidText }}
				</div>
			</div>

			<!-- Arrow Icon -->
			<div class="arrow-icon-wrapper">
				<!-- <img src="@/assets/header/loginarrow.svg" alt="" /> -->
			</div>

			<!-- Send OTP Button -->
			<button @click="sendOTP" class="send-otp-button">SEND OTP</button>

			<!-- Back to Login Link -->
			<div class="back-to-login-section">
				<span class="pointer" @click="clearData(), gotologin()">
					<!-- <img
						src="@/assets/new-web/blue-back-arrow.svg"
						class="back-arrow-icon"
						alt=""
					/> -->
					Back to Login
				</span>
			</div>
		</div>
		<!-- Footer -->
		<div class="forgot-footer">
			Copyrights © 2024 Hire3x - All rights reserved.
		</div>
	</div>
</template>

<script>
import { required, email, maxLength, helpers } from "vuelidate/lib/validators";
import { sendCandOtp } from "../../utils/apiFunctions";
import errorModal from "../../components/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
	name: "Forgotpassword",
	components: {
		Spinner,
	},
	data() {
		return {
			email: "",
			LoaderStatus: false,
			invalidCredential: false,
			invalidText: "",
			isEmailFocused: false,
		};
	},
	mixins: [errorModal],
	validations() {
		return {
			email: {
				required,
				alphaEmail: (value) => {
					if (value === null) return true;
					return /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(value);
				},
				email,
				maxLength: maxLength(64),
			},
		};
	},
	watch: {
		email(value) {
			this.email = value.replace(/\s/, "").toLowerCase();
		},
	},
	methods: {
		clearData() {
			this.email = "";
			this.invalidCredential = false;
			this.invalidText = "";
			this.$v.$reset();
		},
		gotologin() {
			this.$router.push({ name: "Login" });
		},
		setNoAccess(message) {
			this.LoaderStatus = false;
			this.invalidCredential = true;
			this.invalidText = message;
			setTimeout(() => {
				this.invalidText = "";
				this.invalidCredential = false;
			}, 5000);
		},
		async sendOTP() {
			this.$refs.candmail?.blur();
			this.$v.email.$touch();
			if (!this.$v.email.$invalid) {
				this.LoaderStatus = true;
				try {
					let userdata = {
						type: "reset-password",
						email: this.email.trim(),
					};
					this.$store.commit("userVUEX/setUserData", userdata);

					let payload = {
						type: "reset-password",
						email: this.email.trim(),
					};

					const response = await sendCandOtp(payload);
					if (response.status == 200 || response.status == 429) {
						let otpExceeded = false;
						if(response.status == 429) otpExceeded = true;
						this.LoaderStatus = false;
						let retryAfter = response.status == 429 ? response.data.data.cooldownSeconds : response.data.data.retryAfter;
						// Redirect to OTP verification page with email
						this.$router.push({
							path: "/verify-otp",
							query: {
								email: this.email,
								type: "reset-password",
								otpExceeded: otpExceeded,
								retryAfter: retryAfter
							},
						});
					} else {
						this.setNoAccess("This email ID is not registered with Hire3x.");
					}
				} catch (error) {
					this.setNoAccess("This email ID is not registered with Hire3x.");
				}
			}
		},
	},
	created() {
		this.$store.commit("userVUEX/setUserData", {});
	},
};
</script>

<style scoped>
.forgot-password-container {
	height: 100dvh;
	background: linear-gradient(
		to bottom,
		#20639b 0%,
		#09b7c2 50%,
		#ffffff 50%,
		#ffffff 100%
	);
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
}

/* Header Section */
.forgot-header {
	width: 100%;
	text-align: center;
	padding: 40px 20px 60px;
}

.app-title {
	color: #ffffff;
	font-size: 25px;
	font-weight: 500;
	margin: 0;
	font-family: "Poppins", sans-serif;
}

/* Forgot Password Card */
.forgot-card {
	background: #ffffff;
	border-radius: 12px;
	padding: 40px 30px;
	width: 100%;
	max-width: 450px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	margin-top: -40px;
	position: relative;
	z-index: 10;
	height: 100%;
	max-height: 618px;
}

/* Title Section */
.title-section {
	margin-bottom: 30px;
}

.forgot-title {
	font-size: 30px;
	font-weight: 600;
	font-family: "lato", sans-serif;
	color: #464646;
	text-align: center;
}

.forgot-subtitle {
	font-size: 15px;
	font-weight: 500;
	color: #3a3c40;
	font-family: "montserrat", sans-serif;
	text-align: center;
	margin: 0;
}

/* Error Message */
.error-message {
	color: #dc3545;
	font-size: 14px;
	margin-bottom: 15px;
	min-height: 20px;
}

/* Input Groups */
.input-group {
	margin-bottom: 60px;
}

.input-wrapper {
	position: relative;
	width: 100%;
}

.input-label {
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	font-size: 14px;
	font-weight: 500;
	color: #999999;
	pointer-events: none;
	transition: all 0.2s ease;
	background: #ffffff;
	padding: 0 4px;
	z-index: 1;
}

.input-label.active {
	top: 0;
	transform: translateY(-50%);
	font-size: 12px;
	color: #2d5a8a;
	background: #ffffff;
}

.form-input {
	color: #333;
	font-family: Inter, sans-serif;
	font-size: 16px;
	font-weight: 400;
	line-height: 19.36px;
	height: 45px;
	padding: 14px 20px;
	border-radius: 8px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--White, #fff);
	opacity: 1;
}

.form-input:focus {
	outline: none;
	border: 1px solid var(--gray-300, #d0d5dd);
	box-shadow: 0 0 0 3px rgba(45, 90, 138, 0.1);
}

.form-input.error {
	border-color: #dc3545;
}

/* Validation Messages */
.validation-message {
	color: #dc3545;
	font-size: 12px;
	margin-top: 5px;
}

/* Arrow Icon */
.arrow-icon-wrapper {
	margin: 20px 0 10px 10px;
}

.arrow-icon-wrapper img {
	width: auto;
	height: auto;
}

/* Send OTP Button */
.send-otp-button {
	width: 100%;
	padding: 12px;
	background-color: #20639b;
	color: #ffffff;
	border: none;
	border-radius: 6px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	text-transform: uppercase;
	transition: background-color 0.3s;
	margin-bottom: 5px;
}

.send-otp-button:hover {
	background-color: #1e3a5f;
}

/* Back to Login Section */
.back-to-login-section {
	text-align: center;
	margin-top: 20px;
}

.back-to-login-section .pointer {
	color: #2d5a8a;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	gap: 5px;
}

.back-arrow-icon {
	width: auto;
	height: auto;
	margin-right: 5px;
}

/* Footer */
.forgot-footer {
	text-align: center;
	font-size: 12px;
	color: #999999;
	padding-top: 15px;
}
</style>
